// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_int32 from "rescript/lib/es6/caml_int32.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Data_Scoring$Coronate from "./Data_Scoring.bs.js";

function getExpected(a, b) {
  return 1 / (1 + Math.pow(10, (b - a | 0) / 400));
}

function updateRating(rating, expected, actual, current) {
  return Math.round(current + rating * (actual - expected)) | 0;
}

function getKFactor(matchCount) {
  try {
    return Caml_int32.div(800, matchCount);
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === "Division_by_zero") {
      return 800;
    }
    throw exn;
  }
}

function keepAboveFloor(rating) {
  if (rating > 100) {
    return rating;
  } else {
    return 100;
  }
}

function calcNewRatings(whiteRating, blackRating, whiteMatchCount, blackMatchCount, result) {
  var whiteElo = getKFactor(whiteMatchCount);
  var blackElo = getKFactor(blackMatchCount);
  var whiteExpected = getExpected(whiteRating, blackRating);
  var blackExpected = getExpected(blackRating, whiteRating);
  var whiteResult = Data_Scoring$Coronate.Score.toFloat(Data_Scoring$Coronate.Score.fromResultWhite(result));
  var blackResult = Data_Scoring$Coronate.Score.toFloat(Data_Scoring$Coronate.Score.fromResultBlack(result));
  return [
          keepAboveFloor(updateRating(whiteElo, whiteExpected, whiteResult, whiteRating)),
          keepAboveFloor(updateRating(blackElo, blackExpected, blackResult, blackRating))
        ];
}

var EloRank = {
  getKFactor: getKFactor
};

export {
  EloRank ,
  calcNewRatings ,
  
}
/* Data_Scoring-Coronate Not a pure module */
